//const BASE_URL = "http://127.0.0.1:8000";
const BASE_URL = "https://parking-test-deploy.onrender.com";

export default BASE_URL;